<!--
 * @Descripttion: 
 * @Author: juanjuanhui
 * @Date: 2021-11-29 14:32:22
 * @LastEditors: juanjuanhui
 * @LastEditTime: 2022-05-20 14:01:30
-->
<template>
  <div class="content">
    <!-- 订单结算记录 -->
    <div class="title-wrap vertical-line">
      <h2 class="title">
        <span class="txt">订单支付记录</span>
      </h2>
    </div>
    <el-table :data="settleRecord" style="width: 100%">
      <el-table-column label="序号" width="120" align="center">
        <template slot-scope="scope">
          {{ scope.$index + 1 }}
        </template>
      </el-table-column>
      <el-table-column
        prop="settleTime"
        label="支付日期"
        min-width="11%"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="settleAmout"
        label="支付金额（元）"
        min-width="10%"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="remark"
        label="支付说明"
        min-width="14%"
        align="center"
      >
      </el-table-column>

      <el-table-column fixed="right" label="附件" width="200" align="center">
        <template slot-scope="scope">
          <el-button
            type="primary"
            plain
            round
            @click="handleLookFile(fileType, scope.row.id)"
            >点击查看</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!-- 订单结算情况 -->
    <div class="title-wrap vertical-line">
      <h2 class="title">
        <span class="txt">订单结算情况</span>
      </h2>
    </div>
    <el-table
      :data="settleSituation.tWorkSettleListProtocols"
      show-summary
      :summary-method="getSummaries"
      style="width: 100%"
    >
      <el-table-column label="序号" width="120" align="center">
        <template slot-scope="scope">
          {{ scope.$index + 1 }}
        </template>
      </el-table-column>
      <el-table-column
        prop="workTypeName"
        label="作业类型"
        min-width="10%"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="orderTime"
        label="作业时间要求"
        min-width="15%"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="trusteeshipArea"
        label="托管面积（亩）"
        min-width="10%"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="orderUnitPrice"
        label="作业单价（元/亩）"
        min-width="10%"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="trueWorkArea"
        label="作业亩数（亩）"
        min-width="10%"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="orderAmountTotal"
        label="订单总额（元）"
        min-width="10%"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="workAmountTotal"
        label="应付作业金额（元）"
        min-width="10%"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="settleAmout"
        label="已结算金额（元）"
        min-width="10%"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="unSettleWorkAmout"
        label="未结算金额（元）"
        min-width="10%"
        align="center"
      >
      </el-table-column>
    </el-table>
    <!-- 查看文件图片 -->
    <el-image
      class="preview-img"
      ref="previewImg"
      :src="contractFileList[0]"
      :preview-src-list="contractFileList"
    >
    </el-image>
  </div>
</template>

<script>
export default {
  name: "OrderSettlement",
  data() {
    return {
      fileType: 4,
      settleRecord: [], // 订单结算记录
      settleSituation: {}, // 点单结算情况
      contractFileList: [], // 订单原件
    };
  },
  props: {
    orderId: {
      type: String,
    },
  },
  created() {
    this.getSettleList();
    this.getWorkTypeSettleList();
  },
  methods: {
    /**
     * @descripttion: 获取订单结算记录
     * @Author: juanjuanhui
     * @Date: 2021-11-30 11:37:37
     * @param {*} param
     * @return {*}
     */
    getSettleList() {
      let params = { orderId: this.orderId };
      this.$http.order.getSettleList(params).then((res) => {
        this.settleRecord = res.data;
      });
    },
    /**
     * @descripttion: 获取订单结算情况
     * @Author: juanjuanhui
     * @Date: 2021-12-04 15:27:28
     * @param {*} param
     * @return {*}
     */
    getWorkTypeSettleList() {
      let params = { orderId: this.orderId };
      this.$http.order.getWorkTypeSettleList(params).then((res) => {
        this.settleSituation = res.data;
      });
    },
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        if (index < 6) return;
        const values = data.map((item) => Number(item[column.property]));
        if (!values.every((value) => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return Math.round((prev + curr) * 100) / 100;
            } else {
              return prev;
            }
          }, 0);
          //   sums[index] += " 元";
        } else {
          sums[index] = "N/A";
        }
      });

      return sums;
    },
    /**
     * @descripttion: 查看文件
     * @Author: juanjuanhui
     * @Date: 2021-11-30 10:20:36
     * @param {*} id
     */
    handleLookFile(type, bizId) {
      let params = { type, bizId };
      this.getContractFileList(params);
    },
    /**
     * @descripttion: 获取合同附件
     * @Author: juanjuanhui
     * @Date: 2021-11-29 10:18:08
     * @param {*}
     */
    getContractFileList(params) {
      this.$http.common.getContractFileList(params).then((res) => {
        let contractFileList = res.data,
          tempAry = [];
        contractFileList.forEach((item) => {
          tempAry.push(item.picPath);
        });
        this.contractFileList = tempAry;
        if (contractFileList.length > 0) {
          this.$refs.previewImg.showViewer = true;
        } else {
          this.$message({
            message: "暂无附件",
            type: "success",
          });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/mixin.scss";
.content {
  .title-wrap {
    @include plate-title-mutil;
    border-bottom: none;
  }
  ::v-deep .el-table {
    margin-top: 10px;
    border: 1px solid #dfe7eb;
    border-bottom: none;
    .el-button {
      padding: 5px 12px;
    }
  }
}
::v-deep .preview-img {
  position: absolute;
  z-index: -1;
  width: 100px;
  height: 100px;
}
</style>
